export const muteTimeList = [
    {
        name: '100ms',
        value: '100'
    },
    {
        name: '150ms',
        value: '150'
    },
    {
        name: '200ms',
        value: '200'
    },
    {
        name: '300ms',
        value: '300'
    },
    {
        name: '400ms',
        value: '400'
    },
    {
        name: '600ms',
        value: '600'
    }
]
